const request = {
    invalid_input: 'La entrada no es válida. {{detalles}}',
    general: 'Ocurrió un error en la solicitud.',
    range_not_satisfiable: 'El rango no es satisfactorio.',
};
export default Object.freeze(request);
